import { render, staticRenderFns } from "./PendingDocumentationModal.vue?vue&type=template&id=10411344&scoped=true"
import script from "./PendingDocumentationModal.vue?vue&type=script&lang=js"
export * from "./PendingDocumentationModal.vue?vue&type=script&lang=js"
import style0 from "./PendingDocumentationModal.vue?vue&type=style&index=0&id=10411344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10411344",
  null
  
)

export default component.exports